import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';

const styles = ({ screenSizes, spacing }) => ({
  root: {
    paddingLeft: spacing.unit * 7,
    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      '& .grid-mobile': {
        marginLeft: -spacing.unit * 7,
      },
    },
  },
});

const Content = ({ children, classes, fieldChosen }) => (
  <div
    id={`collapse-${fieldChosen}`}
    className={classnames('panel-collapse collapse in', classes.root)}
  >
    {children}
  </div>
);

Content.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fieldChosen: PropTypes.string.isRequired,
};

export default withStyles(styles)(Content);
